import { DeprecatedFormId } from '@furnish-hx/constants/FormId';
import { IDeprecatedForm, IForm, IForms } from '../interfaces/Form';
import defaultForm from './forms/defaultForm';
import tableScandinavianForm from './forms/tableScandinavianForm';
import tableLiveEdgeForm from './forms/tableLiveEdgeForm';
import tableRiverTableForm from './forms/tableRiverTableForm';
import tableFarmForm from './forms/tableFarmForm';
import tableIndustrialForm from './forms/tableIndustrialForm';
import tableConcreteForm from './forms/tableConcreteForm';
import tableMarbleAndStoneForm from './forms/tableMarbleAndStoneForm';
import tableMikadoForm from './forms/tableMikadoForm';
import tableVintageForm from './forms/tableVintageForm';
import tableForm from './forms/tableForm';
import trayForm from './forms/trayForm';
import tableLegsForm from './forms/tableLegsForm';
import meetingTableForm from './forms/meetingTableForm';
import deskForm from './forms/deskForm';
import deskExecutiveForm from './forms/deskExecutiveForm';
import libraryWithNiches from './forms/libraryWithNichesForm';
import libraryWithShelves from './forms/libraryWithShelvesForm';
import libraryWall from './forms/libraryWallForm';
import libraryCompositionForm from './forms/libraryCompositionForm';
import glassWallForm from './forms/glassWallForm';
import glassWallWithBase from './forms/glassWallWithBaseForm';
import glassWallWithFrame from './forms/glassWallWithFrameForm';
import glassWallComplex from './forms/glassWallComplexForm';
import counterBarForm from './forms/counterBarForm';
import counterBarCentralForm from './forms/counterBarCentralForm';
import counterBarCurvedAngleForm from './forms/counterBarCurvedForm';
import counterBarAngleForm from './forms/counterBarAngleForm';
import worktopForm from './forms/worktopForm';
import worktopAssembledForm from './forms/worktopAssembledForm';
import wardrobeRoomForm from './forms/wardrobeRoomForm';
import wardrobeUnderEaves from './forms/wardrobeUnderEavesForm';
import storageUnderStairsForm from './forms/storageUnderStairsForm';
import mirrorForm from './forms/mirrorForm';
import credenzaForm from './forms/credenzaForm';
import shelfForm from './forms/shelfForm';
import closetDoorForm from './forms/closetDoorForm';
import windowsForm from './forms/windowsForm';
import glassShapeForm from './forms/glassShapeForm';
import pavingSlabForm from './forms/pavingSlabForm';
import partitionWallForm from './forms/partitionWallForm';
import showerScreenForm from './forms/showerScreenForm';
import fenceForm from './forms/fenceForm';
import highWindForm from './forms/highWindForm';
import verandaForm from './forms/verandaForm';
import glassGreenHouseForm from './forms/glassGreenHouseForm';
import tvUnitStandForm from './forms/tvUnitStandForm';
import tvUnitSuspendedForm from './forms/tvUnitSuspendedForm';
import staircaseStraightForm from './forms/staircaseStraightForm';
import staircaseSpiralRoundForm from './forms/staircaseSpiralRoundForm';
import staircaseSpiralSquareForm from './forms/staircaseSpiralSquareForm';
import staircaseQuarterTurnForm from './forms/staircaseQuarterTurnForm';
import staircaseHalfTurnForm from './forms/staircaseHalfTurnForm';
import staircaseTurnLandingForm from './forms/staircaseTurnLandingForm';
import dpRestaurantForm from './forms/dpRestaurantForm';
import dpBarForm from './forms/dpBarForm';
import dpWineCellarForm from './forms/dpWineCellarForm';
import dpFastFoodForm from './forms/dpFastFoodForm';
import dpHotelForm from './forms/dpHotelForm';
import dpShopForm from './forms/dpShopForm';
import dpPharmacyForm from './forms/dpPharmacyForm';
import dpRealEstateForm from './forms/dpRealEstateForm';
import dpHairdresser from './forms/dpHairdresserForm';
import dpBeautyInstituteForm from './forms/dpBeautyInstituteForm';
import dpGroceryForm from './forms/dpGroceryForm';
import dpButcherShopForm from './forms/dpButcherShopForm';
import dpCheeseDairyForm from './forms/dpCheeseDairyForm';
import dpBakeryForm from './forms/dpBakeryForm';
import dpWorkspaceForm from './forms/dpWorkspaceForm';
import dpHouseInteriorForm from './forms/dpHouseInteriorForm';
import dpHouseOutsideForm from './forms/dpHouseOutsideForm';
import dpEventsForm from './forms/dpEventsForm';
import dpChildBedroomLayoutForm from './forms/dpChildBedroomLayoutForm';
import wineCellarForm from './forms/wineCellarForm';
import wineCellarDedicatedRoom from './forms/wineCellarDedicatedRoomForm';
import terraceWoodForm from './forms/terraceWoodForm';
import terraceStonesForm from './forms/terraceStoneForm';
import garageDoorForm from './forms/garageDoorForm';
import pergolaClassicForm from './forms/pergolaClassicForm';
import pergolaBioclimaticForm from './forms/pergolaBioclimaticForm';
import claustraForm from './forms/claustraForm';
import shoesCabinetForm from './forms/shoesCabinetForm';
import shelfShoesForm from './forms/shelfShoesForm';
import vegetalWallForm from './forms/vegetalWallForm';
import bedClassicForm from './forms/bedClassicForm';
import bedMezzanineForm from './forms/bedMezzanineForm';
import bedBunkForm from './forms/bedBunkForm';
import windowBlindsIndoorForm from './forms/windowBlindsIndoorForm';
import windowBlindsOutdoorForm from './forms/windowBlindsOutdoorForm';
import consoleSuspendedForm from './forms/consoleSuspendedForm';
import consoleStandForm from './forms/consoleStandForm';
import lowTableForm from './forms/lowTableForm';
import lowTableNoLegsForm from './forms/lowTableNoLegsForm';
import lowTableNestingForm from './forms/lowTableNestingForm';
import lowTableNestingNoLegsForm from './forms/lowTableNestingNoLegsForm';
import fencingForm from './forms/fencingForm';
import defaultConfigFormIds from './DefaultConfigFormIds';
import portalForm from './forms/portalForm';
import kitchenForm from './forms/kitchenForm';

const deprecatedFormConfigs: Partial<{ [key in DeprecatedFormId]: IForm}> = {
    glassWallComplex,
    glassWallWithBase,
    glassWallWithFrame,
    libraryWall,
    libraryWithNiches,
    libraryWithShelves,
    wardrobeUnderEaves,
};

export const deprecatedForms: IDeprecatedForm[] = [
    ...Object.values(DeprecatedFormId).map((formId) => ({
        ...(deprecatedFormConfigs[formId] || defaultForm),
        formId,
    })),
];

// @todo: migrate to object
const forms: IForms = [
    ...deprecatedForms,
    tableForm,
    tableLiveEdgeForm,
    tableMarbleAndStoneForm,
    tableRiverTableForm,
    tableScandinavianForm,
    tableIndustrialForm,
    tableVintageForm,
    tableFarmForm,
    tableConcreteForm,
    tableMikadoForm,
    tableLegsForm,
    trayForm,
    meetingTableForm,
    lowTableForm,
    lowTableNoLegsForm,
    lowTableNestingForm,
    lowTableNestingNoLegsForm,
    deskForm,
    deskExecutiveForm,
    libraryCompositionForm,
    garageDoorForm,
    glassWallForm,
    bedBunkForm,
    bedClassicForm,
    bedMezzanineForm,
    claustraForm,
    consoleStandForm,
    consoleSuspendedForm,
    counterBarForm,
    counterBarCentralForm,
    counterBarCurvedAngleForm,
    counterBarAngleForm,
    worktopForm,
    worktopAssembledForm,
    wardrobeRoomForm,
    storageUnderStairsForm,
    kitchenForm,
    mirrorForm,
    credenzaForm,
    shelfForm,
    shelfShoesForm,
    closetDoorForm,
    windowsForm,
    pavingSlabForm,
    glassShapeForm,
    partitionWallForm,
    pergolaBioclimaticForm,
    pergolaClassicForm,
    portalForm,
    fenceForm,
    fencingForm,
    shoesCabinetForm,
    showerScreenForm,
    highWindForm,
    verandaForm,
    glassGreenHouseForm,
    tvUnitStandForm,
    tvUnitSuspendedForm,
    staircaseStraightForm,
    staircaseSpiralRoundForm,
    staircaseSpiralSquareForm,
    staircaseQuarterTurnForm,
    staircaseHalfTurnForm,
    staircaseTurnLandingForm,
    terraceWoodForm,
    terraceStonesForm,
    vegetalWallForm,
    windowBlindsIndoorForm,
    windowBlindsOutdoorForm,
    wineCellarForm,
    wineCellarDedicatedRoom,
    dpRestaurantForm,
    dpBarForm,
    dpWineCellarForm,
    dpFastFoodForm,
    dpHotelForm,
    dpShopForm,
    dpPharmacyForm,
    dpRealEstateForm,
    dpHairdresser,
    dpBeautyInstituteForm,
    dpGroceryForm,
    dpButcherShopForm,
    dpCheeseDairyForm,
    dpBakeryForm,
    dpWorkspaceForm,
    dpHouseInteriorForm,
    dpHouseOutsideForm,
    dpEventsForm,
    dpChildBedroomLayoutForm,
    ...defaultConfigFormIds.map((formId) => ({ ...defaultForm, formId })),
];

export const formsWithDefault = [...forms, defaultForm];

export default forms;
